/* eslint-disable no-console */

// En este archivo gurado toda la configuracion del firebase para luego importalo en el main.js.

import Vue from "vue"
// import store from "@/store/index.js"

// manejo de firebase 
import firebase from "firebase/app"
import "firebase/analytics"
import "firebase/performance"
import "firebase/messaging"

// firebase metricas -- la configuracion debe ser cambiada segun el proyecto
var firebaseConfig = {
  apiKey: "AIzaSyAckmQKgJk3zA8osr3s2x5F9gftv38d80I",
  authDomain: "centro-de-control-techboss.firebaseapp.com",
  projectId: "centro-de-control-techboss",
  storageBucket: "centro-de-control-techboss.appspot.com",
  messagingSenderId: "882788447895",
  appId: "1:882788447895:web:7c468d074225dcfae51bd2",
  measurementId: "G-C1TBHSCGM4"
};

// Initialize Firebase
const defaultProject = firebase.initializeApp(firebaseConfig)
console.log(defaultProject.name);  // "[DEFAULT]"

// // configuro FCM
// const messaging = firebase.messaging()
// messaging.usePublicVapidKey("BCt5fGbrq02lkCjaT9vdAP7DfF7af3oJHymvUFajTOHhVO38AeVAWq6m7u1T0EixYhwZv0_dAYF3nFXHdFSpEw8")

// messaging.requestPermission().then(() => {
//   // console.log('Notification permission granted.')
//   messaging.getToken().then((token) => {
//     // guardo en storage el token.
//     console.log(token)
//     store.dispatch('settokenFirebase', token)
//   })
// }).catch((err) => {
//   console.log('Unable to get permission to notify.', err)
// })

// messaging.onMessage( payload => {
 
//   /*  Estructura mensaje FCM
//     {data: { code: "9"
//                 message: "Delogueo"
//                 remitente: "ALB"
//                 title: "Deslogueo"
//               }, 
//     from: "315828580733", 
//     priority: "normal", 
//     notification: {title: "Title notification"}, 
//     collapse_key: "type_a"} */

//   // visualizacion mensaje
//   store.dispatch('firebasenotificaciones/SetMensaje',{ title : payload.data.title, message : payload.data.message  } );
//   store.dispatch('firebasenotificaciones/ShowNotificacion',true); 
  
// })

// Herramientas de monitoreo
const analytics =firebase.analytics()
firebase.performance()


Vue.use(firebase)
Vue.prototype.$firebase = firebase
Vue.prototype.$analytics = analytics